export default [
  {
    path: "/pages/:slug",
    name: "viewPage",
    component: () => import('@/pages/page/slug'),
  },
]
